import React from "react";
import AppModal from "../common/AppModal";
import UpdateSchoolForm from "../../forms/UpdateSchoolForm";
import { SchoolResponseDto } from "../../shared/dtos/school/SchoolResponseDto";

interface UpdateSchoolModalProps {
  open: boolean;
  onClose: () => void;
  school: SchoolResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateSchoolModal: React.FC<UpdateSchoolModalProps> = ({
  open,
  onClose,
  school,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Edit School Information"
    width="md"
    loading={loading}
  >
    <UpdateSchoolForm school={school} loading={loading} error={error} />
  </AppModal>
);

export default UpdateSchoolModal;
